__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mattermost/client", "*", () => (Promise.all([__webpack_require__.e(9014), __webpack_require__.e(1751), __webpack_require__.e(9212), __webpack_require__.e(6476), __webpack_require__.e(7782), __webpack_require__.e(5464)]).then(() => (() => (__webpack_require__(99315))))));
			register("history", "4.10.1", () => (__webpack_require__.e(9074).then(() => (() => (__webpack_require__(69074))))));
			register("luxon", "3.3.0", () => (__webpack_require__.e(2950).then(() => (() => (__webpack_require__(52950))))));
			register("react-beautiful-dnd", "13.1.1", () => (Promise.all([__webpack_require__.e(1188), __webpack_require__.e(9180), __webpack_require__.e(7784), __webpack_require__.e(6182), __webpack_require__.e(6403)]).then(() => (() => (__webpack_require__(41188))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d821e2b1db1059bd36112d7587fd1b0912b27626", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(2056), __webpack_require__.e(9180), __webpack_require__.e(7784), __webpack_require__.e(9067)]).then(() => (() => (__webpack_require__(42056))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(3144), __webpack_require__.e(9180)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(6502), __webpack_require__.e(4091), __webpack_require__.e(9180), __webpack_require__.e(5985)]).then(() => (() => (__webpack_require__(54091))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(6502), __webpack_require__.e(5154), __webpack_require__.e(9180)]).then(() => (() => (__webpack_require__(85154))))));
			register("react-redux", "7.2.4", () => (Promise.all([__webpack_require__.e(9798), __webpack_require__.e(9180), __webpack_require__.e(7784), __webpack_require__.e(9575)]).then(() => (() => (__webpack_require__(19798))))));
			register("react-redux", "7.2.4", () => (Promise.all([__webpack_require__.e(1026), __webpack_require__.e(9180), __webpack_require__.e(7784)]).then(() => (() => (__webpack_require__(71026))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(6859), __webpack_require__.e(9180), __webpack_require__.e(5248)]).then(() => (() => (__webpack_require__(76859))))));
			register("react", "17.0.2", () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))));
			register("styled-components", "5.3.6", () => (Promise.all([__webpack_require__.e(6990), __webpack_require__.e(9180), __webpack_require__.e(9907)]).then(() => (() => (__webpack_require__(76990))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};